/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { Badge, Button, Input } from "@repo/ui";
import { Link } from "react-router-dom";
import { CircleX } from "lucide-react";

import { Paths } from "../../routes/paths";

export default function EscalationMatrixFilterBar({ getList, onExport }) {
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState("");
  const filterTimeout = useRef(null);

  /* =========================
     INITIAL LOAD
  ========================= */

  useEffect(() => {
    getList("");
  }, []);

  /* =========================
     DEBOUNCED SEARCH
  ========================= */

  useEffect(() => {
    filterTimeout.current = setTimeout(() => {
      getList(search || "");
      handleAddFilter("search", search, "Search");
    }, 1000);

    return () => clearTimeout(filterTimeout.current);
  }, [search]);

  /* =========================
     FILTER HELPERS
  ========================= */

  const handleAddFilter = (key, value, label) => {
    if (!value) {
      handleClearFilter(key);
      return;
    }

    setFilters((prev) => ({
      ...prev,
      [key]: `${label}: ${value}`,
    }));
  };

  const handleClearFilter = (key) => {
    const updated = { ...filters };
    delete updated[key];

    if (key === "search") {
      setSearch("");
      getList("");
    }

    setFilters(updated);
  };

  const clearAllFilters = () => {
    setSearch("");
    setFilters({});
    getList("");
  };

  /* =========================
     RENDER
  ========================= */

  return (
    <>
      {/* SEARCH + ACTIONS */}
      <div className="flex mb-3 gap-1">
        <div className="w-full">
          <Input
            value={search}
            placeholder="Search"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="flex gap-2">
          <Button variant="secondary">
            <Link to={Paths.addEscalationMatrix}>Create Escalation Matrix</Link>
          </Button>
          <Button variant="secondary" onClick={onExport}>
            Export
          </Button>
        </div>
      </div>

      {/* ACTIVE FILTERS */}
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            key={key}
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
          >
            {value}
            <CircleX onClick={() => handleClearFilter(key)} />
          </Badge>
        ))}

        {Object.keys(filters).length > 0 && (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX onClick={clearAllFilters} />
          </Badge>
        )}
      </div>
    </>
  );
}
